module.exports = __webpack_public_path__ + "img/156.fbe72122.jpg";